import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "../../../api/client";

function useSuperAdminSubscriptions() {
  return useQuery({
    queryKey: ["superadmin", "subscriptions"],
    // El endpoint pagina ({count, results}); la tabla consume el array plano.
    queryFn: () =>
      apiClient
        .get("/api/v1/superadmin/subscriptions/")
        .then((r) => r.data?.results ?? r.data),
  });
}

function useUpdateSubscription() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, ...data }) =>
      apiClient.patch(`/api/v1/superadmin/subscriptions/${id}/`, data).then((r) => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["superadmin", "subscriptions"] }),
  });
}

// Confirma el pago manual → aplica el cambio de plan pendiente y reactiva.
function useConfirmPayment() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id) =>
      apiClient
        .post(`/api/v1/superadmin/subscriptions/${id}/confirm_payment/`)
        .then((r) => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["superadmin", "subscriptions"] }),
  });
}

export { useSuperAdminSubscriptions, useUpdateSubscription, useConfirmPayment };
